import moment from 'moment';
import Swal from "sweetalert2";
import HelperMixin from '../../../Shared/HelperMixin.vue';
import PaginationHelper from '../../../Shared/PaginationHelper.vue';

export default {
    name: 'UnitMeasures',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        await this.CheckLoginStatus();

        if (this.loginDetails) {
            if (this.loginDetails.userType != 1)
                this.logout();
        }

        this.GetInfo(1);
    },

    computed: {
        statsCards() {
            return [
                this.statCard(`إجمالي ${this.ScreenTitle}`, this.Statistics && this.Statistics.count, 'primary', 'ti ti-ruler'),
                this.statCard(`${this.ScreenTitle} المفعلة`, this.Statistics && this.Statistics.active, 'success', 'ti ti-circle-check'),
                this.statCard(`${this.ScreenTitle} المخفية`, this.Statistics && this.Statistics.notActive, 'warning', 'ti ti-eye-off'),
                this.statCard(`${this.ScreenTitle} المحذوفة`, this.Statistics && this.Statistics.deleted, 'danger', 'ti ti-trash'),
            ];
        }
    },

    filters: {
        moment: function (date) {
            if (date === null || date === undefined) {
                return "فارغ";
            }
            return moment(date).format('DD/MM/YYYY');
        },
    },
    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            Search: '',

            ScreenTitle: 'وحدات القياس',
            ScreenTitleSingle: 'وحدة قياس',
            ScreenTitleSingleAl: 'وحدة القياس',

            Info: [],
            Statistics: [],
            SelectedItem: '',

            ruleForm: {
                Id: '',
                Name: '',
                DisplayOrder: 1,
            },
            rules: {
                Name: this.$helper.Required(),
            },
        };
    },

    methods: {
        tableRowNumber(index) {
            return ((Number(this.pageNo) - 1) * Number(this.pageSize)) + index + 1;
        },

        normalizeDisplayOrder(value) {
            const n = Number(value);
            if (!Number.isFinite(n) || n <= 0) {
                return 1;
            }
            return Math.floor(n);
        },

        GetInfo(pageNo) {
            this.pageNo = pageNo || this.pageNo || 1;

            if (!this.Search)
                this.$blockUI.Start();

            this.$http.GetDictionaryUnitMeasures(this.pageNo, this.pageSize, this.Search)
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    this.Info = response.data.info || [];
                    this.pages = response.data.count || 0;
                    this.Statistics = response.data.statistics || {};
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.Info = [];
                    this.pages = 0;
                });
        },

        resetForm() {
            this.ClearForm(this.ruleForm);
            this.ruleForm.Id = '';
            this.ruleForm.Name = '';
            this.ruleForm.DisplayOrder = 1;
        },

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ruleForm.Id = Number(0);
                    this.ruleForm.DisplayOrder = this.normalizeDisplayOrder(this.ruleForm.DisplayOrder);

                    this.$blockUI.Start();
                    this.$http.AddDictionaryUnitMeasure(this.ruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo(1);
                            this.resetForm();
                            this.$helper.DestroyElemntById('CloseAddUnitMeasure');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإضافة', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإضافة', 'حدث خطأ غير متوقع');
                            }
                        });
                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        OpenEditDialog(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.Name = item.name;
            this.ruleForm.DisplayOrder = this.normalizeDisplayOrder(item.displayOrder);
        },

        submitEditForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ruleForm.Id = Number(this.ruleForm.Id);
                    this.ruleForm.DisplayOrder = this.normalizeDisplayOrder(this.ruleForm.DisplayOrder);

                    this.$blockUI.Start();
                    this.$http.EditDictionaryUnitMeasure(this.ruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo(this.pageNo);
                            this.resetForm();
                            this.$helper.DestroyElemntById('CloseEditUnitMeasure');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', 'حدث خطأ غير متوقع');
                            }
                        });
                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        ChangeStatus(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: 'هل أنت متأكد من عملية تغيير حالة العرض؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: 'تأكيد العملية',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.ChangeStatusDictionaryUnitMeasure(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', 'حدث خطأ غير متوقع');
                            }
                        });
                }
            });
        },

        Delete(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: 'هل أنت متأكد من عملية الحذف؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: 'تأكيد العملية',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteDictionaryUnitMeasure(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', 'حدث خطأ غير متوقع');
                            }
                        });
                }
            });
        },
    }
}
